module.exports = __webpack_public_path__ + "media/images/logos/University-of-Bristol-34a9f2a54283131976801a729d2c89aa.svg";